import { useTranslation } from 'react-i18next';
import { StatCard } from '@/shared/ui';
import type { FormattedStats } from '../../model';

interface ServiceStatsProps {
  stats: Partial<FormattedStats> | null;
  isLoading: boolean;
}

export function ServiceStats({ stats, isLoading }: ServiceStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      <StatCard label={t('welcome.chart.totreceived.label')} value={stats?.totalReceived || ''} isLoading={isLoading} />
      <StatCard
        label={t('welcome.chart.totpartners.label')}
        value={stats?.servicePartners || ''}
        isLoading={isLoading}
      />
      <StatCard label={t('welcome.chart.totreleased.label')} value={stats?.totalReleased || ''} isLoading={isLoading} />
    </div>
  );
}
